import { render, staticRenderFns } from "./Publicacao.vue?vue&type=template&id=2f2fbd4e&scoped=true"
import script from "./Publicacao.vue?vue&type=script&lang=js"
export * from "./Publicacao.vue?vue&type=script&lang=js"
import style0 from "./Publicacao.vue?vue&type=style&index=0&id=2f2fbd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2fbd4e",
  null
  
)

export default component.exports